import keyMirror from 'keymirror';

const ClientConstants = keyMirror({
  RESET_CLIENT_SURVEY_DATA: null,
  CLEAR_INVALID_FORM_NAME_TO_SCROLL: null,
  SET_ANSWER: null,
  SET_ANSWER_LIST: null,
  POP_FROM_VISITED_PAGES: null,
  PUSH_TO_VISITED_PAGES: null,
  SET_VISITED_QUESTIONS: null,
  SET_CURRENT_PAGE: null,
  SET_CLIENT_SURVEY_BLOCK_LIST: null,
  SET_CLIENT_SURVEY_CONDITIONAL_SHOW_LOGIC_QUESTIONS: null,
  TOGGLE_CONDITIONAL_SHOW_LOGIC_QUESTION_VISIBILITY: null,
  SET_CLIENT_SURVEY_SETTINGS: null,
  SET_INVALID_FORM_NAME_TO_SCROLL: null,
  SET_RESPONSE_UUID: null,
  SHOW_ERROR: null,
  ADD_BLOCK_TO_ANSWER_PENDING_QUEUE: null,
  REMOVE_BLOCK_FROM_ANSWER_PENDING_QUEUE: null,
  CLEAR_AWAIT_NEXT_BUTTON_ID: null,
  SET_AWAIT_FOR_ANSWER_NEXT_BUTTON_ID: null,
  SET_LOGIC_REDIRECT_TO_QUESTION_ID: null,
  SET_PENDING_LOGIC_REDIRECT_TO_QUESTION_ID: null,
  SET_IS_CAPTCHA_VERIFIED: null,
  SET_IS_CAPTCHA_PENDING: null,
  SET_IS_SURVEY_COMPLETED: null,
  SET_SHARED_HEADER: null,
  SET_VISITED_PAGES: null,
});

export default ClientConstants;
